import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cdf15d5a&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=cdf15d5a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf15d5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdf15d5a')) {
      api.createRecord('cdf15d5a', component.options)
    } else {
      api.reload('cdf15d5a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=cdf15d5a&scoped=true&lang=pug", function () {
      api.rerender('cdf15d5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vip/contracts/contractInfo/index.vue"
export default component.exports